module.exports = __webpack_public_path__ + "img/pdf.0cd0fc7d.svg";